import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = { class: "bg-white mt-5 p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6 w-md" }
const _hoisted_3 = { class: "text-lg font-semibold text-gray-800 dark:text-white/90 flex justify-between items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  class: "flex justify-center py-10",
  style: {"font-size":"2rem"}
}
const _hoisted_7 = { class: "space-y-6 border-t border-gray-100 p-5 sm:p-6 dark:border-gray-800" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "pt-5" }
const _hoisted_11 = { class: "text-red-500 text-center mb-3" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, [
        (($setup.user_id ?? -1) < 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Register User "))
          : _createCommentVNode("v-if", true),
        (($setup.user_id ?? -1) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Reset Password "))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, _cache[9] || (_cache[9] = [
        _createElementVNode("span", null, [
          _createElementVNode("i", { class: "fa-solid fa-spinner animate-spin" }),
          _createTextVNode(" Loading...")
        ], -1 /* CACHED */)
      ]), 512 /* NEED_PATCH */), [
        [_vShow, $setup.loading]
      ]),
      _withDirectives(_createElementVNode("h2", {
        style: {"font-size":"1.2rem"},
        class: "text-red-500 text-center"
      }, _toDisplayString($setup.token_error), 513 /* TEXT, NEED_PATCH */), [
        [_vShow, $setup.token_error]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          (($setup.user_id ?? -1) < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Username ", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.username) = $event)),
                  tabindex: "110",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys($event => ($setup.register_user($setup.username, $setup.email, $setup.password, $setup.repeat_password)), ["enter"])),
                  class: _normalizeClass(["dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30", { 'border-red-500': !!$setup.username_error }])
                }, null, 34 /* CLASS, NEED_HYDRATION */), [
                  [_vModelText, $setup.username]
                ]),
                _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.username_error), 513 /* TEXT, NEED_PATCH */), [
                  [_vShow, $setup.username_error]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (($setup.user_id ?? -1) < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Email ", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.email) = $event)),
                  tabindex: "120",
                  onKeyup: _cache[3] || (_cache[3] = _withKeys($event => ($setup.register_user($setup.username, $setup.email, $setup.password, $setup.repeat_password)), ["enter"])),
                  class: _normalizeClass(["dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30", { 'border-red-500': !!$setup.email_error }])
                }, null, 34 /* CLASS, NEED_HYDRATION */), [
                  [_vModelText, $setup.email]
                ]),
                _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.email_error), 513 /* TEXT, NEED_PATCH */), [
                  [_vShow, $setup.email_error]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Password ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.password) = $event)),
              tabindex: "130",
              onKeyup: _cache[5] || (_cache[5] = _withKeys($event => ($setup.register_user($setup.username, $setup.email, $setup.password, $setup.repeat_password)), ["enter"])),
              class: _normalizeClass(["dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30", { 'border-red-500': !!$setup.password_error }])
            }, null, 34 /* CLASS, NEED_HYDRATION */), [
              [_vModelText, $setup.password]
            ]),
            _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.password_error), 513 /* TEXT, NEED_PATCH */), [
              [_vShow, $setup.password_error]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Repeat Password ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.repeat_password) = $event)),
              tabindex: "140",
              onKeyup: _cache[7] || (_cache[7] = _withKeys($event => ($setup.register_user($setup.username, $setup.email, $setup.password, $setup.repeat_password)), ["enter"])),
              class: _normalizeClass(["dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30", { 'border-red-500': !!$setup.repeat_password_error }])
            }, null, 34 /* CLASS, NEED_HYDRATION */), [
              [_vModelText, $setup.repeat_password]
            ]),
            _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.repeat_password_error), 513 /* TEXT, NEED_PATCH */), [
              [_vShow, $setup.repeat_password_error]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString($setup.form_errors), 1 /* TEXT */),
            _createVNode(_component_basic_button, {
              onClick: _cache[8] || (_cache[8] = $event => ($setup.register_user($setup.username, $setup.email, $setup.password, $setup.repeat_password)))
            }, {
              default: _withCtx(() => [
                (($setup.user_id ?? -1) < 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Register User "))
                  : _createCommentVNode("v-if", true),
                (($setup.user_id ?? -1) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Reset Password "))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, !$setup.token_error && !$setup.loading]
      ])
    ])
  ]))
}